import { FC } from "react";
import { NavLink } from "react-router";
import { useSelector } from "react-redux";

import { ERoutes } from "../../../../constants/routes";
import { selectActiveCompetitorsCount, selectTotalCompetitorsCount } from "../../../../store/selectors/brands";
import { selectActivePromptsCount, selectTotalPromptsCount } from "../../../../store/selectors/prompts";
import { selectActiveModelsCount, selectTotalModelsCount } from "../../../../store/selectors/models";

import styles from "./Config.module.css";



const Config: FC = () => {
  const activePromptsCount = useSelector(selectActivePromptsCount);
  const totalPromptsCount = useSelector(selectTotalPromptsCount);
  
  const activeCompetitorsCount = useSelector(selectActiveCompetitorsCount);
  const totalCompetitorsCount = useSelector(selectTotalCompetitorsCount);
  
  const activeModelsCount = useSelector(selectActiveModelsCount);
  const totalModelsCount = useSelector(selectTotalModelsCount);

  return (
    <div className={styles["config"]}>
      <ul className={styles["config__list"]}>
        <li className={styles["config__item"]}>
          <NavLink className={({ isActive }) => isActive ? styles["config__link--active"] : styles["config__link"]} to={ERoutes.SettingsCompetitors}>
            <p>Competitors ({activeCompetitorsCount}/{totalCompetitorsCount})</p>
          </NavLink>
        </li>
        <li className={styles["config__item"]}>
          <NavLink className={({ isActive }) => isActive ? styles["config__link--active"] : styles["config__link"]} to={ERoutes.SettingsPrompts}>
            <p>Prompts ({activePromptsCount}/{totalPromptsCount})</p>
          </NavLink>
        </li>
        <li className={styles["config__item"]}>
          <NavLink className={({ isActive }) => isActive ? styles["config__link--active"] : styles["config__link"]} to={ERoutes.SettingsModels}>
            <p>Models ({activeModelsCount}/{totalModelsCount})</p>
          </NavLink>
        </li>
      </ul>
    </div>
  );
};

export default Config;
